import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Navbar from "./Components/Navbar/Navbar";

// Wrap ScrollToTop inside Router context

function Home() {
  return (
    <div>
      <Navbar />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        {/* <Route path="/about" component={About} /> */}
      </Switch>
    </Router>
  );
}

export default App;
